var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g(_vm._b({staticClass:"ui-icon-control terminal-icon-control",class:[
    `ui-icon-control--${_vm.size}`,
    `ui-icon-control--${_vm.variant}`,
    {
      'is-active': _vm.active,
      'is-disabled': _vm.disabled,
      'terminal-control-click-flash': _vm.flashing
    }
  ],attrs:{"type":"button","title":_vm.$t(_vm.title),"aria-label":_vm.$t(_vm.ariaLabel || _vm.title),"aria-pressed":_vm.toggle ? String(_vm.active) : null,"disabled":_vm.disabled}},'button',_vm.$attrs,false),_vm.$listeners),[(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }